// Copyright 2020 Sorama B.V.

import { PLATFORM } from "aurelia-pal";
import { GuidanceTopicType, IGuidanceTopic } from "catalogs/GuidanceCatalog";
import { WorkflowModuleType } from "libraries/WorkflowFramework/Interfaces/IWorkflowModuleConfig";
import { WorkflowModes } from "services/WorkflowModes/WorkflowModes";

export class MeasurementSetupGuidanceCatalog {
    static MeasurementSetupMS1Module: IGuidanceTopic = {
        name: "Setup_Creation",
        modulePath: PLATFORM.moduleName("guidance/MeasurementSetup/MS1MeasurementSetupCreation.html"),
        title: "Measurement Setup Creation",
        moduleType: WorkflowModuleType.Help,
        relevantWorkflowModes: WorkflowModes.All.filter((mode) => mode.canUseCAM64AndCAM1K),
        topicType: GuidanceTopicType.Question,
        topicContent: "How do I create a measurement setup?",
        catchwords: [""],
    };
}
